export const SESSION_ERROR_TYPES = {
  INVALID_NONCE: 'INVALID_NONCE',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  GENERIC_ERROR: 'GENERIC_ERROR',
  MISSING_PARAMS: 'MISSING_PARAMS'
} as const;

export type SessionErrorType = typeof SESSION_ERROR_TYPES[keyof typeof SESSION_ERROR_TYPES];

// Configurable error messages - update these to change user-facing text
export const SESSION_ERROR_MESSAGES = {
  MISSING_PARAMS: {
    title: 'Missing Required Information',
    message: 'Missing required information. Please access this page through the proper sign-in flow.',
    showReturnButton: true
  },
  INVALID_NONCE: {
    title: 'Invalid or Expired Link',
    message: 'This link has expired or is invalid. Please request a new link from your application.',
    showReturnButton: true
  },
  SESSION_EXPIRED: {
    title: 'Session Expired',
    message: 'Your session has expired. Redirecting you back to the application...',
    showReturnButton: false 
  },
  GENERIC_ERROR: {
    title: 'Verification Error',
    message: 'We\'re unable to verify your session. Please try signing in again.',
    showReturnButton: true
  }
} as const;

// Helper function to get error message configuration
export function getErrorMessage(errorType: SessionErrorType | string) {
  return SESSION_ERROR_MESSAGES[errorType as SessionErrorType] || SESSION_ERROR_MESSAGES.GENERIC_ERROR;
}
